/* Edge-fade cue for side-scrolling chip rows (League tabs, guide chips, page tabs).
   Sets data-fade to the edges that still have chips past them; the mask lives in tailgater-brand.css.
   Rows that fit get an empty data-fade, so nothing fades. */
(function () {
  if (window.tgUi) return;
  window.tgUi = true;

  var SELECTOR = '.tgx-tabs, .sg-chips ul, .tgp-tabs';

  function update(row) {
    var max = row.scrollWidth - row.clientWidth;
    var edges = [];
    if (max > 2) {
      if (row.scrollLeft > 2) edges.push('l');
      if (row.scrollLeft < max - 2) edges.push('r');
    }
    var value = edges.join(' ');
    if (row.getAttribute('data-fade') !== value) row.setAttribute('data-fade', value);
  }

  function init() {
    var rows = document.querySelectorAll(SELECTOR);
    if (!rows.length) return;
    var observer = window.ResizeObserver && new ResizeObserver(function (entries) {
      entries.forEach(function (entry) { update(entry.target); });
    });
    rows.forEach(function (row) {
      update(row);
      row.addEventListener('scroll', function () { update(row); }, { passive: true });
      if (observer) observer.observe(row);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* A11Y-1: product gallery. Horizon marks the current thumbnail with aria-selected, which only means something inside a
   tablist; mirror it to aria-current and drop it. The photo strip becomes a focusable, labelled region so keyboard users
   can scroll it. Horizon's core gallery files are over the edit limit, so this runs here. */
(function () {
  function fixThumb(b) {
    var sel = b.getAttribute('aria-selected');
    if (sel === null) return;
    if (sel === 'true') b.setAttribute('aria-current', 'true');
    else b.removeAttribute('aria-current');
    b.removeAttribute('aria-selected');
  }
  function init() {
    document.querySelectorAll('media-gallery slideshow-slides').forEach(function (s) {
      s.setAttribute('tabindex', '0');
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', 'Product photos');
    });
    var thumbs = document.querySelectorAll('media-gallery .slideshow-controls__thumbnail');
    if (!thumbs.length) return;
    thumbs.forEach(fixThumb);
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) { fixThumb(m.target); });
    });
    thumbs.forEach(function (b) { mo.observe(b, { attributes: true, attributeFilter: ['aria-selected'] }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Phone menu (brief §7, Shop menu MUSTs 3-4). Horizon's drawer is over the edit limit, so: the footer from the
   #tg-drawer-extras template (sections/tg-announce.liquid) goes in once, above the drawer's utility links, and each
   category name ("Keep It Cold") becomes a link to its page; the arrow still opens the sub-categories. */
(function () {
  function init() {
    var tpl = document.getElementById('tg-drawer-extras');
    var util = document.querySelector('.menu-drawer__utility-links');
    if (tpl && util && !document.querySelector('.tg-drawer-foot')) util.parentNode.insertBefore(tpl.content.cloneNode(true), util);
    /* Flatten "More" (Shop menu MUST 2): its links take its place, and Shop all moves to the top of Shop. */
    var more = document.querySelector('.menu-drawer a[id$="-more"]:not([data-tg-flat])');
    if (more) {
      var items = [];
      try { items = JSON.parse((document.getElementById('tg-menu-more') || {}).textContent || '[]'); } catch (e) {}
      var li = more.closest('li');
      if (li && items.length) {
        var list = li.parentNode;
        items.forEach(function (it) {
          var n = li.cloneNode(true), a = n.querySelector('a');
          a.href = it.u; a.removeAttribute('id'); a.setAttribute('data-tg-flat', '');
          var t = a.querySelector('.menu-drawer__menu-item-text') || a; t.textContent = it.t;
          if (/^shop all$/i.test(it.t)) list.insertBefore(n, list.firstChild); else list.insertBefore(n, li);
        });
        li.remove();
      }
    }
    var map = {};
    try { map = JSON.parse((document.getElementById('tg-menu-urls') || {}).textContent || '{}'); } catch (e) {}
    document.querySelectorAll('summary.menu-drawer__menu-item--parent').forEach(function (sum) {
      var span = sum.querySelector('.menu-drawer__menu-item-text');
      if (!span || span.tagName === 'A') return;
      var url = map[span.textContent.trim()];
      if (!url) return;
      var a = document.createElement('a');
      a.className = span.className + ' tg-drawer-cat';
      a.href = url;
      a.textContent = span.textContent.trim();
      a.addEventListener('click', function (e) { e.stopPropagation(); });
      span.replaceWith(a);
    });
  }
  /* Horizon's own script rebuilds the drawer when it opens, so re-apply after any change (init skips what's done). */
  var queued = false;
  function start() {
    init();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; init(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Type-ahead refill (brief §8k). Shopify's type-ahead returns 10 products at most; color siblings fold into one, which
   can leave 2. snippets/predictive-search-products-list.liquid tags those lists; this swaps in the full search's list. */
(function () {
  function refill(ul) {
    var q = ul.getAttribute('data-tg-refill');
    ul.removeAttribute('data-tg-refill');
    fetch('/search?view=suggest&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !ul.isConnected) return;
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.predictive-search-results__wrapper-products');
        if (src && src.children.length > ul.children.length) ul.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }
  function scan() { document.querySelectorAll('ul[data-tg-refill]').forEach(refill); }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();

/* v42 (CRO, Clarity 10-29..31: ~15 silent taps on "Sign me up"): every Pregame email form checks the address itself. The
   browser's own check failed silently or hid its tooltip under the keyboard. Bad address: one line under the field (aria-live),
   focus back on the field, the button stays enabled, GA4 pregame_email_invalid. Good address on a sign-up form: "Signing you up…".
   Listens on window, ahead of the sign_up tracker and the Klaviyo subscribe listener, so a bad address reaches neither. /pages/your-team has its own form
   (sections/tg-your-team). Copy: EIC, approved by the CEO (v42 rulings, tasks/web/theme-status.md). */
(function () {
  var MSG = "That email doesn't look right. Check the @ and everything after it.";
  var OK = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function kind(f) {
    if (!f || !f.querySelector || !f.querySelector('input[type="email"]')) return '';
    var tags = f.elements['contact[tags]'];
    if (tags && /newsletter|pregame/.test(tags.value)) return 'pregame';
    if (f.closest && f.closest('.tgg-sv, [data-tg-capture]')) return 'guide_sheet';
    return '';
  }
  function hintFor(f, input) {
    var h = f.querySelector('.tg-email-hint');
    if (!h) {
      h = document.createElement('p');
      h.className = 'tg-email-hint';
      h.setAttribute('aria-live', 'polite');
      h.id = (input.id || 'tg-em') + '-hint';
      var at = input.closest('.field, .tgpg__field, .email-signup__input-group') || input;
      at.insertAdjacentElement('afterend', h);
    }
    return h;
  }
  function init() { document.querySelectorAll('form').forEach(function (f) { if (kind(f)) f.noValidate = true; }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // On window (capture), so it runs before every document listener: a bad address never fires sign_up (tailgater-track.js)
  // or the Klaviyo subscribe below.
  window.addEventListener('submit', function (e) {
    var f = e.target, k = kind(f);
    if (!k) return;
    var input = f.querySelector('input[type="email"]');
    var v = input.value.trim();
    var h = hintFor(f, input);
    if (!OK.test(v)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      h.textContent = MSG;
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', h.id);
      input.focus();
      if (window.gtag) gtag('event', 'pregame_email_invalid', { form: k, empty: v ? 'no' : 'yes' });
      return;
    }
    h.textContent = '';
    input.removeAttribute('aria-invalid');
    if (k === 'pregame') {
      var b = f.querySelector('button[type="submit"], input[type="submit"]');
      if (b) { if (b.tagName === 'INPUT') b.value = 'Signing you up…'; else b.textContent = 'Signing you up…'; }
    }
  }, true);
  document.addEventListener('input', function (e) {
    var f = e.target.form;
    if (f && kind(f) && e.target.type === 'email') { var h = f.querySelector('.tg-email-hint'); if (h) h.textContent = ''; e.target.removeAttribute('aria-invalid'); }
  });
})();

/* Pregame sign-ups -> Klaviyo list SxfhnU (the Pregame list; its Welcome flow triggers on it). Every Pregame form is a
   Shopify customer form (tg-pregame, guide sheet, Lot index, Horizon's footer email-signup); restock forms are tagged
   "restock" and skipped. The Shopify signup still happens; this adds the profile to the list, with its source.
   Also the guide's "Email it to me" contact form when its "Also send me The Pregame" box is ticked. */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.elements || !f.elements.form_type) return;
    var tick = f.elements['contact[Also send The Pregame]'];
    /* Guide sheet forms (the v29 capture band, data-tg-capture, and the save card): every valid submit records "Requested game-day
       sheet" (Klaviyo metric TMaWc4; flow Sfe5L7 sends the sheet). Contracts: tasks/specs/game-day-sheet-flow.md and
       tasks/email/guide-capture-spec-2026-10-30.md. keepalive, because the contact form navigates away. */
    var card = f.closest && f.closest('.tgg-sv, [data-tg-capture]');
    var src = (card && card.dataset.tgCapture) || 'guide-save-card';
    var sh = card && card.querySelector('[data-tg-sheet]');
    if (sh) {
      var em = f.elements['contact[email]'] ? f.elements['contact[email]'].value.trim() : '';
      if (em && (!f.checkValidity || f.checkValidity())) {
        var d = sh.dataset;
        try {
          fetch('https://a.klaviyo.com/client/events/?company_id=TgUAvs', {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'event', attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Requested game-day sheet' } } },
              profile: { data: { type: 'profile', attributes: { email: em, properties: {
                tg_guide_handle: d.handle || '', tg_team: d.team || '', tg_capture_source: src } } } },
              unique_id: em + '|' + d.sheet + '|' + Math.floor(Date.now() / 60000),
              properties: { stadium: d.stadium, guide_url: d.guide, sheet_url: d.sheet, team: d.team || '',
                pregame_opt_in: !!(tick && tick.checked), source: src } } } })
          }).catch(function () {});
          if (window.klaviyo) window.klaviyo.identify({ email: em });
        } catch (err) {}
      }
    }
    var tags;
    if (f.elements.form_type.value === 'contact' && tick && tick.checked) tags = 'newsletter,source-' + (sh ? src : 'guide-email');
    else if (f.elements.form_type.value !== 'customer') return;
    else tags = f.elements['contact[tags]'] ? f.elements['contact[tags]'].value : 'newsletter';
    var email = f.elements['contact[email]'] ? f.elements['contact[email]'].value.trim() : '';
    if (tags.indexOf('newsletter') < 0 || !email || (f.checkValidity && !f.checkValidity())) return;
    var src = (tags.match(/source-([\w-]+)/) || [])[1] || location.pathname;
    /* v40 (SEO Chief spec): a guide sheet opt-in carries the guide's team and the signup source, so the Pregame leads with it. */
    var pp = {};
    if (sh) {
      var sd = sh.dataset;
      pp = { signup_source: 'guide', signup_guide: sd.handle || '', signup_position: 'sheet' };
      if (sd.teamHandle) { pp.team = sd.teamHandle; pp.team_name = sd.team || ''; pp.team_set_at = new Date().toISOString(); }
      try { var ft = JSON.parse(sessionStorage.getItem('tg_ft') || '{}'); for (var fk in ft) pp[fk] = ft[fk]; } catch (er) {}
    }
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TgUAvs', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: sh ? 'Guide: ' + (sh.dataset.handle || '') : 'Pregame: ' + src,
          profile: { data: { type: 'profile', attributes: { email: email, properties: pp } } } },
          relationships: { list: { data: { type: 'list', id: 'SxfhnU' } } } } })
      }).catch(function () {});
      /* Tie this browser's earlier views to the new subscriber, so Browse Abandonment works before their first email click. */
      if (window.klaviyo) window.klaviyo.identify({ email: email });
    } catch (err) {}
  }, true);
})();

/* PDP-1 (UI/UX audit 2026-10-28): on phones the sticky Add to cart shows from page load. Horizon's bar only opens once the
   buy buttons have scrolled off the TOP; on a 812px phone they sit at ~1,300px, so nothing buyable was on screen until then.
   Shown whenever the buy buttons are out of view (above or below) and the footer isn't near; hidden while they're on screen.
   Sold-out products stay hidden by Horizon's CSS (data-variant-available); affiliate products are skipped. */
(function () {
  if (!window.IntersectionObserver || !window.matchMedia('(max-width: 749px)').matches) return;
  function init() {
    var host = document.querySelector('sticky-add-to-cart');
    var bar = host && host.querySelector('[ref="stickyBar"]');
    var buy = document.querySelector('.product-information .buy-buttons-block');
    if (!bar || !buy || document.querySelector('.product-information .tg-aff')) return;
    var footer = document.querySelector('footer');
    var buyIn = true, footIn = false;
    function set() {
      var v = (!buyIn && !footIn) ? 'true' : 'false';
      if (bar.dataset.stuck !== v) bar.dataset.stuck = v;
    }
    new IntersectionObserver(function (es) { buyIn = es[es.length - 1].isIntersecting; set(); }).observe(buy);
    if (footer) new IntersectionObserver(function (es) { footIn = es[es.length - 1].isIntersecting; set(); }, { rootMargin: '200px 0px 0px 0px' }).observe(footer);
    /* Horizon's component boots after this and writes data-stuck="false" while the buttons are below the screen; put our
       state back whenever anything else changes it. set() only writes on a difference, so this can't loop. */
    new MutationObserver(set).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Recipe "Jump to recipe / Print" bar on phones (mobile system §6f): a fixed copy of .tgp-btns at the bottom, shown while
   the original buttons are scrolled away and the recipe card (#recipe) hasn't been reached; hidden otherwise. */
(function () {
  if (!window.IntersectionObserver || !window.matchMedia('(max-width: 749px)').matches) return;
  function init() {
    var btns = document.querySelector('.tgp-btns');
    var recipe = document.getElementById('recipe');
    if (!btns || !recipe || !btns.querySelector('a[href="#recipe"]')) return;
    var bar = btns.cloneNode(true);
    bar.classList.add('tgp-btns--bar');
    bar.hidden = true;
    bar.setAttribute('aria-label', 'Recipe shortcuts');
    document.body.appendChild(bar);
    var btnsGone = false, recipeReached = false;
    function set() { bar.hidden = !(btnsGone && !recipeReached); }
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      btnsGone = !e.isIntersecting && e.boundingClientRect.top < 0;
      set();
    }).observe(btns);
    new IntersectionObserver(function (es) {
      var e = es[es.length - 1];
      recipeReached = e.isIntersecting || e.boundingClientRect.top < 0;
      set();
    }).observe(recipe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
